import { Stack } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { createContext, ReactNode, useContext } from 'react';

import { FullPageSpinner } from '@zeta-core';
import { FactFindService } from '@zeta-services';
import { IFactFindEntity } from '@zeta-types';

interface IClientProfileLayoutType {
  children: ReactNode;
}

export interface IStateType {
  adviceTypes: null;
  advisorID: string;
  caseID: string;
  investorID: string;
  isExistingClient: boolean;
  nextMeeting: string;
  retailClientName: string;
  retailUserEmail: string;
  retailUserID: string;
  stage: string;
}

const ClientProfileContext = createContext<IFactFindEntity>({});

export const useClientProfileContext = () => useContext(ClientProfileContext);

const ClientProfileLayout = ({ children }: IClientProfileLayoutType) => {
  const { isPending: isMutateInitFactFindPending } = useMutation({ mutationFn: FactFindService().initFactFind });

  if (isMutateInitFactFindPending) {
    return <FullPageSpinner />;
  }

  return (
    <ClientProfileContext.Provider>
      <Stack>{children}</Stack>
    </ClientProfileContext.Provider>
  );
};

export default ClientProfileLayout;
